import { createFileRoute } from "@tanstack/react-router";
import StaffIndividualViewPage from "@/pages/StaffIndividualViewPage";

export const Route = createFileRoute(
  "/$leaid/_error-wrapper/records/staff/$staffId"
)({
  component: StaffIndividualViewPage,
});
